import React from 'react';

import { prop } from 'ramda';

import Table from 'components/shared/Table';

import SmartRow from '../SmartRow';
import getColumns from './columns';
import styles from './index.module.css';

const headerColumnProps = (col) => ({
  className: prop(`column-${col.id}`, styles),
});

const cellProps = (cell) => ({
  className: prop(`column-${cell.column.id}`, styles),
});

export default ({ data, pagination, onEdit, onOrder, onView, isLoading, setPage, setLimit, params }) => (
  <Table
    data={data}
    pagination={pagination}
    limit={params?.limit || 25}
    columns={getColumns({ params, onOrder, onEdit, onView })}
    getHeaderProps={headerColumnProps}
    getCellProps={cellProps}
    renderRowSubComponent={({ row }) => {
      return <SmartRow data={row.original} onOpenPreview={onView} />;
    }}
    actionsCellsm
    isLoading={isLoading}
    onSelectPage={setPage}
    onLimitChange={setLimit}
  />
);
